import { TruncatableText } from '@routable/components';
import React from 'react';
import { v4 } from 'uuid';
import { ZIndexLayers } from 'constants/ui';
import { getFieldErrors } from 'helpers/errors';
import { getZIndex } from 'helpers/zIndex';
const FormFieldErrors = ({ errors = {}, fieldName }) => {
    if (!errors) {
        return null;
    }
    let currentFormFieldErrors = errors;
    if (typeof errors === 'object' && !Array.isArray(errors)) {
        currentFormFieldErrors = getFieldErrors(errors, fieldName);
    }
    if (!currentFormFieldErrors || !Array.isArray(currentFormFieldErrors) || !currentFormFieldErrors.length) {
        return null;
    }
    return (React.createElement("div", { className: "form-error-container max-w-full", "data-testid": "formError", style: { zIndex: getZIndex(ZIndexLayers.ABOVE_BASE) } }, currentFormFieldErrors.length === 1 ? (React.createElement(TruncatableText, { text: currentFormFieldErrors[0] })) : (currentFormFieldErrors.map((element) => (React.createElement("p", { key: v4() },
        '• ',
        element))))));
};
export default FormFieldErrors;
